// Keep one canonical hierarchy. A parent is never dragged or duplicated in state.
export function buildMenuTree(menus) {
    const nodes = new Map(menus.map(menu => [Number(menu.id), {
        ...menu, id: Number(menu.id), parentId: Number(menu.parentId || 0), children: []
    }]));
    const roots = [];
    nodes.forEach(node => {
        const seen = new Set([node.id]);
        let parent = nodes.get(node.parentId);
        while (parent) {
            if (seen.has(parent.id)) throw new Error('Menu hierarchy contains a cycle. Please correct the menu settings.');
            seen.add(parent.id);
            parent = nodes.get(parent.parentId);
        }
        if (node.parentId && !nodes.has(node.parentId)) {
            throw new Error(`Parent menu is missing for ${node.title}. Please correct the menu settings.`);
        }
        if (node.parentId) nodes.get(node.parentId).children.push(node);
        else roots.push(node);
    });
    const sort = list => {
        list.sort((a, b) => Number(a.order || 0) - Number(b.order || 0) || a.id - b.id);
        list.forEach(node => sort(node.children));
        return list;
    };
    return sort(roots);
}

// Containers have no independent access; route-bearing parents remain selectable.
export function menuTargets(node) {
    const own = !node.children.length || (node.uri && node.uri !== '#') ? [node.id] : [];
    return [...own, ...node.children.flatMap(menuTargets)];
}

export function assignedMenuIds(tree, targetIds) {
    const result = [];
    const visit = node => {
        const children = node.children.map(visit).some(Boolean);
        const assigned = targetIds.has(node.id) || children;
        if (assigned) result.push(node.id);
        return assigned;
    };
    tree.forEach(visit);
    return result.sort((a, b) => a - b);
}

export function projectMenus(tree, assigned, side, search = '') {
    const query = search.trim().toLowerCase();
    const visit = (node, parentMatches = false) => {
        const matches = parentMatches || !query || node.title.toLowerCase().includes(query);
        const children = node.children.map(child => visit(child, matches)).filter(Boolean);
        const isTarget = !node.children.length || (node.uri && node.uri !== '#');
        const ownVisible = isTarget && (side === 'assigned' ? assigned.has(node.id) : !assigned.has(node.id)) && matches;
        if (!ownVisible && !children.length) return null;
        return { ...node, children, ownVisible,
            targets: [...(ownVisible ? [node.id] : []), ...children.flatMap(child => child.targets)] };
    };
    return tree.map(node => visit(node)).filter(Boolean);
}
